/* eslint-disable react/forbid-prop-types */
import React, { useState } from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import tw from "tailwind.macro"
import LinkTo from "./LinkTo"
import CircleIcon from "../elements/CircleIcon"
import { textStyleSmall } from "../elements/Text"

const Wrapper = styled.div`
  ${tw`lg:flex lg:justify-between lg:items-center`}
`

const directionStyle = css`
  ${textStyleSmall};
  ${tw`mb-4 lg:mb-0`};
  ${tw`text-center`}
`

const Prev = styled.div`
  ${directionStyle};
  ${tw`lg:text-left`}
`

const Next = styled.div`
  ${directionStyle};
  ${tw`lg:text-right lg:ml-auto`};
`

const Label = styled.span`
  ${tw`lg:block font-normal pr-4 lg:pr-0 text-grey-darkest`}
`

const PrevNext = ({ next, prev }) => {
  const [prevActive, setPrevActive] = useState(false)
  const [nextActive, setNextActive] = useState(false)
  const linkStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }

  return (
    <Wrapper>
      {prev && (
        <Prev
          onMouseEnter={() => {
            setPrevActive(true)
          }}
          onMouseLeave={() => {
            setPrevActive(false)
          }}
        >
          <LinkTo style={linkStyles} href={prev.fields.slug}>
            <CircleIcon
              active={prevActive}
              style={tw`mr-2`}
              icon="chevronLeft"
              size={64}
            />
            <div>
              <Label>Previous:</Label>
              {prev.frontmatter.title}
            </div>
          </LinkTo>
        </Prev>
      )}

      {next && (
        <Next
          onMouseEnter={() => {
            setNextActive(true)
          }}
          onMouseLeave={() => {
            setNextActive(false)
          }}
        >
          <LinkTo style={linkStyles} href={next.fields.slug}>
            <div>
              <Label>Next:</Label>
              {next.frontmatter.title}
            </div>
            <CircleIcon
              active={nextActive}
              style={tw`ml-2`}
              icon="chevronRight"
              size={64}
            />
          </LinkTo>
        </Next>
      )}
    </Wrapper>
  )
}

export default PrevNext

PrevNext.propTypes = {
  next: PropTypes.object,
  prev: PropTypes.object,
}

PrevNext.defaultProps = {
  next: null,
  prev: null,
}
